
export function items(state) {
  return state.items
}

export function item(state) {
  return state.item
}

export function share(state) {
  return state.share
}

export function pagination(state) {
  return state.pagination
}
